import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const PageWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'picker'
    'image'
    'list';
  gap: ${space['space-600']};
  max-width: ${layout.maxWidth};
  margin: 0 auto;

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 40% 1fr;
    grid-template-areas:
      'image picker'
      'image list';
    column-gap: ${space['space-1200']};
    row-gap: ${space['space-300']};
    padding: ${space['space-800']} ${layout.horizontalPadding};
    align-items: start;
  }
`;

export const PickerSlot = styled.div`
  grid-area: picker;
  padding: 0 ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0;
  }
`;

export const LeftColumn = styled.div`
  grid-area: image;
  text-align: center;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    top: ${space['space-800']};
    align-self: flex-start;
    text-align: center;
  }
`;

export const CategoryImage = styled(EntityImage)`
  width: calc(100% - ${space['space-600']} * 2);
  margin: 0 auto;
  border-radius: ${size.radius['radius-md']};
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 100%;
    margin: 0;
    aspect-ratio: 4 / 3;
  }
`;

export const CategoryImagePlaceholder = styled.div`
  width: calc(100% - ${space['space-600']} * 2);
  margin: 0 auto;
  border-radius: ${size.radius['radius-md']};
  aspect-ratio: 16 / 9;
  background: ${semantic.bg.surfaceSubtle};

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 100%;
    margin: 0;
    aspect-ratio: 4 / 3;
  }
`;

export const CategoryHeading = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: ${space['space-400']} 0 0;
  line-height: ${primitives.typography.lineHeight.tight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
    margin: ${space['space-600']} 0 0;
  }
`;

export const DescriptionWrapper = styled.div`
  margin: ${space['space-300']} ${space['space-400']} 0;

  p,
  button {
    color: ${semantic.text.secondary};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin: ${space['space-300']} 0 0;
  }
`;

export const RightColumn = styled.div`
  grid-area: list;
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  min-width: 0;
  padding: 0 ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0;
  }
`;
